import { Chip } from "@platform/design-system";

import {
  CASE_STATE_CHIP_COLORS,
  CASE_STATE_LABELS,
  type CaseState,
} from "./caseStates";

import type { ReactNode } from "react";

/** A case's state, as a status chip. */
export const CaseStateChip = ({
  state,
}: {
  readonly state: CaseState;
}): ReactNode => (
  <Chip
    data-testid={`golden-case-state-${state}`}
    size="small"
    variant="subtle"
    leadingVisual={false}
    color={CASE_STATE_CHIP_COLORS[state]}
    label={CASE_STATE_LABELS[state]}
  />
);
